export default __webpack_public_path__ + "static/media/dune_analytics.33fd529a.gif";